import View from 'views/base/view';
import BlocksView from 'views/block/block-collection-view';
import FeedbackService from 'services/course-handler-services/feedback-service';
import AnimationService from 'services/event-handler-services/animation-service';
import utils from 'lib/utils';
import MenuTemplate from './templates/menu';
import Chaplin from 'chaplin';
import _ from 'lodash';
import AniJS from 'AniJS';
import $ from 'jquery';

const MenuView = View.extend({
  autoRender: true,
  className: 'menu',
  template: MenuTemplate,
  listSelector: '.menu-items',
  animationDuration: 0,
  regions: {
    blocks: '.blocks',
    feedback: '.feedback',
  },
  initialize: function (options) {
    utils.loadPageSRText(this.model.get('title'));

    this.subView = options.subView;
    if (!options.subView) {
      Chaplin.mediator.publish('page:state:initialized', this);
      Chaplin.mediator.subscribe('block:feedback', this.renderFeedback, this);
    }
    this.script = utils.tryRequire(`menu/${this.model.get('key')}/${this.model.get('key')}`) || {};
    if (this.script.initialized) {
      this.script.initialized.call(this.script, this);
    }
    this.on('addedToDOM', _.bind(this.renderBlocks, this));
    View.prototype.initialize.apply(this, arguments);
  },
  renderBlocks: function () {
    this.delegate('click', '[data-close=true]', e => {
      e.preventDefault();
      this.trigger('close', this);
    });
    const blocksLoaded = () => {
      if (!this.subView) {
        Chaplin.mediator.publish('page:state:loaded', this);
      }
      if (this.script.loaded) {
        this.script.loaded.call(this.script, this);
      }
      AniJS.run();
      if (this.model.get('startAnimation')) {
        AnimationService.queueAnimationsRun();
      }
      this.model.set('state', 'playing');
      this.trigger('page:state:change', this);
      requestAnimationFrame(() => {
        $('#page-loading').text('').attr('aria-hidden', true);
        $(window).scrollTop(0);
      });
    };
    if (this.model.get('blocks')) {
      const blocksView = new BlocksView({
        collection: this.model.get('blocks'),
        region: 'blocks',
        script: this.script ? this.script.block : undefined,
        parent: this,
        pageView: this,
      });
      this.subview('blocks', blocksView);
      // eslint-disable-next-line no-unused-vars
      const readyToLoad = () => blocksView.isLoaded();
      if (blocksView.isLoaded()) {
        blocksLoaded();
      } else {
        this.listenTo(blocksView, 'block:state:loaded', () => blocksLoaded());
      }
    } else {
      blocksLoaded();
    }
  },
  renderFeedback: function (feedback, callbacks) {
    FeedbackService.displayFeedback(this, feedback, callbacks);
  },
  dispose: function () {
    if (this.script.unloading) {
      this.script.unloading.call(this.script, this, function () {});
    }
    // If `context` is null, removes all callbacks with that function.
    Chaplin.mediator.unsubscribe('block:feedback', this.renderFeedback, null);
    View.prototype.dispose.apply(this, arguments);
  },
});

export default MenuView;
